<div class="container container-account container-company-account">

  <div class="card mt-4">

    <div class="card-body">

      <h3 class="card-title">{{'Account' | translate}}</h3>

      <div class="row">

        <div class="col-12 col-md-6">

          <h4>{{'Photo' | translate}}</h4>

          <div class="profile-image-wrapper">

            <div class="editable-group">
              <div class="edit-icon cursor-pointer">
                <fa-icon [icon]="faEdit" (click)="editAvatar()"></fa-icon>
              </div>
            </div>

            <div class="profile-image-holder circle">
              <img [src]="entity.avatarUri ? entity.avatarUri : avatarPlaceholder" >
            </div>
          </div>

        </div>

        <div class="col-12 col-md-6">

          <h4>{{'Contact information' | translate}}</h4>

          <div class="row">

            <!-- contact -->
            <div class="col-12 col-md-12 contact-details">

              <div class="form-group">
                <label>{{'Phone' | translate}}</label>
                <input type="tel" class="form-control" [(ngModel)]="entity.phoneNumber" />
              </div>

              <div class="form-group">
                <label>{{'Email' | translate}}</label>
                <input type="email" class="form-control" readonly [(ngModel)]="entity.emailAddress" />
              </div>

            </div>

          </div>

          <h4>{{'Receive emails' | translate}}</h4>

          <div class="row">
            <!-- email settings -->
            <div class="col-12 email-settings mt-4">

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" id="allowEmailNotifications" type="checkbox" [(ngModel)]="entity.allowEmailNotifications" />
                  <label class="custom-control-label" for="allowEmailNotifications">{{'I want to get email notifications' | translate}}</label>
                </div>
              </div>

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" id="isSubscribedToNewsletter" type="checkbox" [(ngModel)]="entity.isSubscribedToNewsletter" />
                  <label class="custom-control-label" for="isSubscribedToNewsletter">{{'I want to receive newsletters' | translate}}</label>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>

      <div class="btn-toolbar justify-content-end">
        <button class="btn btn-primary" (click)="Save()">
          {{'Save' | translate}}
        </button>
      </div>


      <div class="change-password mt-4">

        <h4>{{'Change password' | translate}}</h4>

        <a [href]="passwordResetUrl" class="btn btn-outline-primary">
          {{'Change password' | translate}}
        </a>

      </div>

    </div>
  </div>
</div>
